export default __webpack_public_path__ + "static/media/ISSO CLASS-2 EXAM PATTERN 2026-27.955f1395.pdf";